import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import AdTypeMenuItem from './AdTypeMenuItem';
import AdTypeMenuHeading from './AdTypeMenuHeading';
import { Partner } from '../partners/partner';

const AdTypeNativeMenu = props => {
  const { partner, onSelectMenu, $state } = props;

  return (
    <Fragment>
      <AdTypeMenuHeading
        onClick={() => props.onSelectMenu('main')}
        title="Native"
      />

      <div className="ad-type-menu__rich-media">
        {partner.hasAdType('native_display') && (
          <AdTypeMenuItem
            heading="Native Display"
            subheading="Generate a native unit that drives to a URL via direct clickout"
            iconSrc="https://legacy-design-assets.s3.amazonaws.com/images/ad-types/display.png"
            onClick={() => {
              $state.go('creativePreview.edit.example', {
                id: 'websiteVisit'
              });
            }}
            testId="native-display"
          />
        )}
        {partner.hasAdType('isi') && (
          <AdTypeMenuItem
            heading="Native ISI"
            subheading="Create a Native ad with Important Safety Information"
            iconSrc="https://legacy-design-assets.s3.amazonaws.com/images/ad-types/isi.png"
            onClick={() => onSelectMenu('isi')}
            testId="native-isi"
          />
        )}
        {partner.hasAdType('thumbnail_carousel') && (
          <AdTypeMenuItem
            heading="Thumbnail Carousel"
            subheading="Multiple images that auto rotate"
            iconSrc="https://legacy-design-assets.s3.amazonaws.com/images/ad-types/rm-slideshow.png"
            onClick={() => {
              props.$state.go('creativePreview.edit.example', {
                id: 'slideshow'
              });
            }}
            testId="thumbnail-carousel"
          />
        )}
        {partner.hasAdType('full_ad_carousel') && (
          <AdTypeMenuItem
            heading="Full Ad Carousel"
            subheading="Multiple images, headlines, and descriptions, each can have a unique URL"
            iconSrc="https://legacy-design-assets.s3.amazonaws.com/images/ad-types/rm-carousel.png"
            onClick={() => {
              props.$state.go('creativePreview.edit.example', {
                id: 'fullAdCarousel'
              });
            }}
            testId="full-ad-carousel"
          />
        )}
        {partner.hasAdType('scroller') && (
          <AdTypeMenuItem
            heading="Scroller"
            subheading="Give users the opportunity to reveal a large image as they scroll through a publisher's feed."
            iconSrc="https://legacy-design-assets.s3.amazonaws.com/images/ad-types/rm-scroller.png"
            onClick={() => {
              props.$state.go('creativePreview.edit.example', {
                id: 'scroller'
              });
            }}
            testId="scroller"
          />
        )}
      </div>
    </Fragment>
  );
};

AdTypeNativeMenu.propTypes = {
  $state: PropTypes.object.isRequired,
  partner: PropTypes.instanceOf(Partner).isRequired,
  onSelectMenu: PropTypes.func.isRequired
};

export default AdTypeNativeMenu;
